import React from "react";
import ProductFieldInput from "../ProductFieldInput";
import { Popup } from "semantic-ui-react";

const BasicInfoFields = ({ context, translate }) => (
    <div>
        {context.isRequiredField('code') && <Popup trigger={
        <ProductFieldInput name='code' title={translate("tools.fields.code")} context={context}
                           errors={["code", "prefix"]}/>
        }
               on='focus'
               header={translate("tools.fields.code")}
               content='Die Artikelnummer besteht grundsätzlich aus dem Lieferantenprefix und der Artikelnummer des Lieferanten. Beispiel: RUK (Prefix für Rutishauser) + 47480715 (Artikelnummer von Lieferant). Sollte es sich um ein Artikel mit Jahrgang handeln, so muss dieser immer noch angefügt werden, falls nicht bereits vorhanden. (2018 -> 18)'
        />}
        {context.isRequiredField('code2') && <Popup trigger={
            <ProductFieldInput name='code2'
                               title={translate("tools.fields.code2") + (context.state.product.parent_product ? " (Matrix-EAN: " + context.state.product.parent_product.code2 + ")" : "")}
                               context={context}/>
        }
               on='focus'
               header={translate("tools.fields.code2")}
               content='Der EAN ist der Strichcode des Produkts. Jahrgänge können unterschiedliche EANs haben und sollten immer überprüft werden. Falls der EAN unter Matrix-EAN bereits eingetragen ist, muss dieser nicht zusätzlich vermerkt werden. Falls ein Artikel mehrere EANs hat, können diese durch ein Komma getrennt eingefügt werden.'
        />}
        {context.isRequiredField('code3') && <Popup trigger={
            <ProductFieldInput name='code3' title={translate("tools.fields.code3")}
                               context={context}/>
        }
               on='focus'
               header={translate("tools.fields.code3")}
               content='Artikelnummer des Lieferanten. Falls der Lieferant keine Artikelnummer vergeben hat, muss unsere eigene Artikelnummer verwendet werden'
        />}
        {context.isRequiredField('name') && <Popup trigger={
            <ProductFieldInput name='name' title={translate("tools.fields.name")}
                               context={context}/>
        }
               on='focus'
               header={translate("tools.fields.name")}
               content='Die Artikelbezeichnung sollte wie vom Leiferanten vorgegeben übernommen werden. Falls der Artikel jedoch keinen EAN aufweist, sollte die Bezeichnung evtl. angepasst werden, so dass der Artikel eindeutig und ohne Verwechslungsgefahr im System und an der Kasse gefunden werden kann.'
        />}
        {context.isRequiredField('description') && <ProductFieldInput name='description' title={translate("tools.fields.description")}
                           context={context}/>}
        {context.isRequiredField('manufacturerName') && <ProductFieldInput name='manufacturerName' title={translate("tools.fields.manufacturer")}
                           context={context}/>}
        {context.isRequiredField('volume') &&

            <Popup trigger={
                <ProductFieldInput name='volume'
                                   title={translate("tools.fields.volume") + " [ml]"}
                                   context={context} integer/>
            }
                   on='focus'
                   header='Volumen'
                   content='Volumeninhalt des Produktes in ml'
            />
        }


    </div>
);

export default BasicInfoFields;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/BasicInfos/components/BasicInfoFields/index.js